import { createContext } from "react";

export const TimetablesContext = createContext();